import React, { useEffect, useState } from 'react'
import Button from '../components/Button'
import { Link, useHistory } from "react-router-dom";
import Header from '../components/Header';
import AccountDropdown from '../components/AccountDropdown';
import cookie from "../libs/cookie/client";
import HomeSvg from '../components/HomeSvg';

const Home = () => {

    const history = useHistory();
    const [isLogin, setIsLogin] = useState(false);
    const [dataLength, setdataLength] = useState(cookie.getItem('datatablength'));

    const goToLogin = () => {
        history.push("/login/");
    }

    useEffect(() => {
        setdataLength(cookie.getItem('datatablength'))
        if (cookie.getItem('authorizationKey') == null || cookie.getItem('email') == null) {
            setIsLogin(false)
        } else {
            setIsLogin(true)
        }
        
    }, []);

    // console.log("home detail");
    // console.log(cookie.getItem('needsassesmentid'));
    // console.log(cookie.getItem('userid'));
    // console.log(cookie.getItem('email'));
   
    return (
        <div className="bg-bottom bg-cover bg-no-repeat min-h-screen flex flex-col items-center relative bg-primary-extraLight z-10">
            <HomeSvg />
            <Header
                hideSalutation={true}
                hideBreadcrumb={true}
                rightContent={isLogin ? <AccountDropdown /> : <Button btnStyle="primary" onClick={() => goToLogin()} text="Log in"/>}
            />
            <h1 className="font-bold text-4xl text-center leading-snug homepage-heading">Match your <span className="text-secondary">GIS</span> needs<br />with the right solutions</h1>
            <div className="relative z-10">
                {dataLength < 5 ?  <Link to="/area-of-interest/" className="block mt-11 px-11 py-3.5 rounded-full text-white bg-secondary border-secondary hover:bg-secondary-dark font-bold text-lg border-5 uppercase">Start</Link> : <Link to={"/dashboard/" + cookie.getItem('needsassesmentid')} className="block mt-11 px-11 py-3.5 rounded-full text-white bg-secondary border-secondary hover:bg-secondary-dark font-bold text-lg border-5 uppercase">Dashboard</Link>}
                
            </div>
        </div>
    )
}

export default Home
